






























import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class PrescriptionAlertsCounterHeader extends BaseComponent {
  @Prop()
  public alerts: any[];

  countError = 0;
  countWarning = 0;
  twoCol = false;

  status = 'error';

  @Watch('alerts', { immediate: true })
  onAlertsChange() {
    if (!this.alerts) {
      return;
    }

    this.countError = this.alerts.filter((a) => a.acao == 'IMPEDITIVO').length;
    this.countWarning = this.alerts.filter((a) => a.acao == 'ALERTA').length;
    this.twoCol = this.countError > 0 && this.countWarning > 0;
  }

  getErrorMessage() {
    return `${this.countError} IMPEDITIVO${this.countError > 1 ? 'S' : ''}`;
  }

  getAlertMessage() {
    return `${this.countWarning} ALERTA${this.countWarning > 1 ? 'S' : ''}`;
  }

  getPrefixMessage() {
    if (!this.twoCol) {
      return `PRESCRIÇÃO COM `;
    }
    return '';
  }
}
